import log from 'loglevel';
// Enable logger on development
if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'production') {
    log.enableAll();
}
//# sourceMappingURL=logger.js.map